export { default as TeamAvatar } from "./TeamAvatar";
